/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Assetseyebrow1Inputs */

const id_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset dan artefak`)
};

const ms_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aset dan artefak`)
};

const da_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets og artefakter`)
};

const de_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets und Artefakte`)
};

const en_us2_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets and artifacts`)
};

const es_es2_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets y artefactos`)
};

const es_mx2_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets y artefactos`)
};

const fil_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga asset at artifact`)
};

const fr_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets et artefacts`)
};

const it_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset e artefatti`)
};

const hu_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-ek és artefaktumok`)
};

const nl_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets en artefacten`)
};

const no_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiendeler og artefakter`)
};

const pl_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets i artefakty`)
};

const pt_br2_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets e artefatos`)
};

const pt_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets e artefactos`)
};

const ro_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset-uri și artefacte`)
};

const fi_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resurssit ja artfaktit`)
};

const sv_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgångar och artefakter`)
};

const vi_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets và artefact`)
};

const tr_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assetler ve yapıtlar`)
};

const cs_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assety a artefakty`)
};

const bg_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets и артефакти`)
};

const ru_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ассеты и артефакты`)
};

const uk_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assets та артефакти`)
};

const ar_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأصول والتحف`)
};

const hi_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एसेट्स और कलाकृतियाँ`)
};

const th_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสเซทและอาร์ทิแฟกต์`)
};

const ja_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットとアーティファクト`)
};

const zh_cn2_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源与制品`)
};

const zh_hant1_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資源與製品`)
};

const ko_sandboxes_assetseyebrow1 = /** @type {(inputs: Sandboxes_Assetseyebrow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 및 아티팩트`)
};

/**
* | output |
* | --- |
* | "Assets and artifacts" |
*
* @param {Sandboxes_Assetseyebrow1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_assetseyebrow1 = /** @type {((inputs?: Sandboxes_Assetseyebrow1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Assetseyebrow1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_assetseyebrow1(inputs)
	if (locale === "ms") return ms_sandboxes_assetseyebrow1(inputs)
	if (locale === "da") return da_sandboxes_assetseyebrow1(inputs)
	if (locale === "de") return de_sandboxes_assetseyebrow1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_assetseyebrow1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_assetseyebrow1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_assetseyebrow1(inputs)
	if (locale === "fil") return fil_sandboxes_assetseyebrow1(inputs)
	if (locale === "fr") return fr_sandboxes_assetseyebrow1(inputs)
	if (locale === "it") return it_sandboxes_assetseyebrow1(inputs)
	if (locale === "hu") return hu_sandboxes_assetseyebrow1(inputs)
	if (locale === "nl") return nl_sandboxes_assetseyebrow1(inputs)
	if (locale === "no") return no_sandboxes_assetseyebrow1(inputs)
	if (locale === "pl") return pl_sandboxes_assetseyebrow1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_assetseyebrow1(inputs)
	if (locale === "pt") return pt_sandboxes_assetseyebrow1(inputs)
	if (locale === "ro") return ro_sandboxes_assetseyebrow1(inputs)
	if (locale === "fi") return fi_sandboxes_assetseyebrow1(inputs)
	if (locale === "sv") return sv_sandboxes_assetseyebrow1(inputs)
	if (locale === "vi") return vi_sandboxes_assetseyebrow1(inputs)
	if (locale === "tr") return tr_sandboxes_assetseyebrow1(inputs)
	if (locale === "cs") return cs_sandboxes_assetseyebrow1(inputs)
	if (locale === "bg") return bg_sandboxes_assetseyebrow1(inputs)
	if (locale === "ru") return ru_sandboxes_assetseyebrow1(inputs)
	if (locale === "uk") return uk_sandboxes_assetseyebrow1(inputs)
	if (locale === "ar") return ar_sandboxes_assetseyebrow1(inputs)
	if (locale === "hi") return hi_sandboxes_assetseyebrow1(inputs)
	if (locale === "th") return th_sandboxes_assetseyebrow1(inputs)
	if (locale === "ja") return ja_sandboxes_assetseyebrow1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_assetseyebrow1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_assetseyebrow1(inputs)
	return ko_sandboxes_assetseyebrow1(inputs)
});
export { sandboxes_assetseyebrow1 as "sandboxes.assetsEyebrow" }